import {createFileRoute} from '@tanstack/react-router';

import MedicationRequestList from '@/patient/views/medicationRequest/MedicationRequestList';

export const Route = createFileRoute('/(patient)/medication-requests')({
  component: MedicationRequestList
});
